import Style from "./styles/Homepage.module.scss";

import { Link } from "react-router-dom";

function Homepage() {
	return (
		<div className={Style.bg}>
			<div className={Style.container}>
				<div className={Style.abu}>
					<div className={Style.about}>
						<div className={Style.logo}>Photoboard</div>
						<div className={Style.desc}>
							A personal mood board to store creative screenshots
						</div>
						<nav className={Style.navbar}>
							<Link to="/login">
								<button className={Style.login}>Login </button>
							</Link>
							<Link to="/signup">
								<button className={Style.signup}>Sign up </button>
							</Link>
						</nav>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Homepage;
